import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { useNumberFormatter } from '../../../../../hooks/useNumberFormatter';

export const AcquisitionCompose = ({ compose }) => {
  const { t } = useTranslation();
  const { formatNumber } = useNumberFormatter();

  return (
    <table className='compose-table'>
      <tbody>
        <tr className='compose-row-main-content'>
          <td>{t('last_approved_bid_amount_current')}</td>
          <td>$ {formatNumber(compose.currentApprovedAmountBID)}</td>
        </tr>
        <tr className='compose-row-item-content'>
          <td className='division-border'>{t('last_procurement_plan_amount')}</td>
          <td className='division-border'>$ {formatNumber(compose.procurementPlanAmountBID)}</td>
        </tr>

        <tr className='compose-row-item-content'>
          <td>{t('last_contracted_processes')}</td>
          <td>$ {formatNumber(compose.contractedProcessesBID)}</td>
        </tr>
        <tr className='compose-row-secondary-content'>
          <td>{t('last_contracts_in_execution')}</td>
          <td>$ {formatNumber(compose.contractUndeExecutionBID)}</td>
        </tr>
        <tr className='compose-row-secondary-content'>
          <td className='division-border'>{t('last_terminated_contracts')}</td>
          <td className='division-border'>$ {formatNumber(compose.contractFinishedBID)}</td>
        </tr>

        <tr className='compose-row-item-content'>
          <td>{t('last_pending_processes')}</td>
          <td>$ {formatNumber(compose.pendingProcessBID)}</td>
        </tr>
        <tr className='compose-row-secondary-content'>
          <td>{t('supervision_plan_activity_state_1')}</td>
          <td>$ {formatNumber(compose.processOngoingBID)}</td>
        </tr>
        <tr className='compose-row-secondary-content'>
          <td className='division-border'>{t('new_provided')}</td>
          <td className='division-border'>$ {formatNumber(compose.expectedBID)}</td>
        </tr>

        <tr className='compose-row-main-content'>
          <td>{t('last_local_contribution_amount')}</td>
          <td>$ {formatNumber(compose.currentApprovedAmountCounterPartLocal)}</td>
        </tr>
        <tr className='compose-row-item-content'>
          <td className='division-border'>{t('last_procurement_plan_amount')}</td>
          <td className='division-border'>$ {formatNumber(compose.procurementPlanAmountCounterPartLocal)}</td>
        </tr>
        <tr className='compose-row-item-content'>
          <td className='division-border'>{t('last_unallocated_amount_in_the_procurement_plan')}</td>
          <td className='division-border'>$ {formatNumber(compose.unallocatedAmountProcurementPlanCounterPartLocal)}</td>
        </tr>
        <tr className='compose-row-main-content'>
          <td>{t('last_cofinancing_amount')}</td>
          <td>$ {formatNumber(compose.currentApprovedAmountCofinancing)}</td>
        </tr>
      </tbody>
    </table>
  )
}
